export default {
  data: () => ({

    rawData:        null,
    dataSet:        null,

    canvasForms:    null,
    canvasYard:     null,

    title:          null,
    scroll:         null,
    summary:        null,
    header:         null,
    columns:        null,

    current: {status: 'ALL',}
    
  }),


  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },


  methods: {
    set_Gradients() {

    },
  }

}